import { useState ,useEffect,useContext} from "react";
import { AppContext } from "../AppContext";
import { Link } from "react-router-dom";
import "./design.css";
export default function Project() {
  const { data } = useContext(AppContext);
  const [state, setstate] = useState(0);
  const [val, setval] = useState(null);
  const [open, setOpen] = useState(false);
 
  function scrollTop (){
    document.getElementById("app").scrollTo({
      top: 0,
      behavior: "smooth" // 平滑滚动
    }); 
  }
 
  useEffect(() => {

    
  }, []); // 空数组 => 只在首次挂载时执行（等价于 componentDidMount）

  return (
    <div id="pdesign">
      <img src={`/image/10.png`} className="pageTitle" />
      <div  className="pContent" >
        <div className="card">
          <div className="line1">
            <span>安普蕾-韩国直营店</span>
             <Link to="/design/1"><span>点击查看 {">"}</span></Link>
          </div>  
          <div className="line2">
            <img src="./image/封面韩国直营店-55.png" />
          </div>  
        </div>   
        <div className="card">
          <div className="line1">
            <span>安普蕾-沈阳K11直营店</span>
             <Link to="/design/2"><span>点击查看 {">"}</span></Link>
          </div>  
          <div className="line2">
            <img src="./image/封面沈阳K11.png" />
          </div>  
        </div>    
        <div className="card">
          <div className="line1">
            <span>安普蕾-延吉百丽城店</span>
             <Link to="/design/3"><span>点击查看 {">"}</span></Link>
          </div>  
          <div className="line2">
            <img src="./image/封面延吉i-57.png" />
          </div>  
        </div>  
        <div className="card">
          <div className="line1">
            <span>安普蕾-北京国贸店</span>
             <Link to="/design/4"><span>点击查看 {">"}</span></Link>
          </div>  
          <div className="line2">
            <img src="./image/封面北京国贸店-56.png" />
          </div>  
        </div>
        <div className="card">
          <div className="line1">
            <span>安普蕾-沈阳嘉里城店</span>
             <Link to="/design/5"><span>点击查看 {">"}</span></Link>
          </div>  
          <div className="line2">
            <img src="./image/空间设计：嘉里城店封面.png" />
          </div>  
        </div>        
      </div>
      
      
      <section  onClick={()=>scrollTop()} id="toTop"><span >PAGE TOP</span></section>
    </div>
  );
}